import { z } from "zod";
import {
  CAM_LICENSE_END_DATE,
  CAM_LICENSE_NO,
  CAM_LICENSE_START_DATE,
  FILLING_DUE_DATE,
  LAST_AGM_DATE,
  STATE_TAX_ID,
  FED_TAX_ID,
} from "./consts";

export const licenseSchema = z.object({
  [FED_TAX_ID]: z.string().optional(),
  [STATE_TAX_ID]: z.string().optional(),
  [CAM_LICENSE_NO]: z.string().optional(),
  [CAM_LICENSE_START_DATE]: z
    .union([
      z.string().refine((val) => !val || !isNaN(Date.parse(val)), {
        message: "Invalid date format",
      }),
      z.date(),
    ])
    .optional(),
  [CAM_LICENSE_END_DATE]: z
    .union([
      z.string().refine((val) => !val || !isNaN(Date.parse(val)), {
        message: "Invalid date format",
      }),
      z.date(),
    ])
    .optional(),
  [LAST_AGM_DATE]: z
    .union([
      z.string().refine((val) => !val || !isNaN(Date.parse(val)), {
        message: "Invalid date format",
      }),
      z.date(),
    ])
    .optional(),
  [FILLING_DUE_DATE]: z
    .union([
      z.string().refine((val) => !val || !isNaN(Date.parse(val)), {
        message: "Invalid date format",
      }),
      z.date(),
    ])
    .optional(),
});

export type licenseFormValues = z.infer<typeof licenseSchema>;